import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appLimitDecimalDigits]',
})
export class LimitDecimalDigitsDirective {
  @Input() decimals: number = -1;
  @Input() isNumberInput = false;

  specialKeys = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Del',
    'Delete',
  ];

  private check(value: string, separator: string) {
    if (this.decimals - value.split(separator)?.[1]?.length <= 0) {
      return false;
    } else {
      return true;
    }
  }

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.isNumberInput && this.decimals >= 0) {
      if (this.decimals <= 0 && (event.key === '.' || event.key === ',')) {
        event.preventDefault();
      } else {
        let current: string = this.el.nativeElement.value;
        const pointIndex = current.indexOf('.');
        const commaIndex = current.indexOf(',');
        if (pointIndex >= 0) {
          if (
            !this.check(current, '.') &&
            !this.specialKeys.includes(event.key)
          ) {
            event.preventDefault();
          }
        } else if (commaIndex >= 0) {
          if (
            !this.check(current, ',') &&
            !this.specialKeys.includes(event.key)
          ) {
            event.preventDefault();
          }
        }
      }
    }
  }
}
